export const PROOF_WINDOW_SCHEMA = "aevion.proof-window-projection.v0.1";

export type MissionState =
  | "CONTRACTED"
  | "EXECUTING"
  | "OBSERVING"
  | "VERIFYING"
  | "REPAIRING"
  | "RELEASE_READY"
  | "SHIPPED"
  | "HOLD";

export type EvidenceState =
  | "ACTIVE"
  | "CANDIDATE"
  | "LOCALLY_VERIFIED"
  | "FORMALLY_CHECKED"
  | "REPRODUCED"
  | "EXTERNALLY_REPRODUCED"
  | "REJECTED"
  | "HOLD";

export interface ProofWindowProjection {
  schema_version: typeof PROOF_WINDOW_SCHEMA;
  mission_id: string;
  public_title: string;
  mission_state: MissionState;
  evidence_state: EvidenceState;
  gate_decision: "ALLOW" | "STEP_UP" | "HOLD" | "DENY";
  mandatory_passed: number;
  mandatory_total: number;
  cost_usd: number;
  hold_reason_code: string;
  last_receipt_sha256: string;
  updated_at_utc: string;
  training_rights: string;
  claim_ceiling: "SANITIZED_READ_MODEL_NOT_RAW_EVIDENCE";
}

export interface ProofWindowResponse {
  schema_version: "aevion.proof-window-api.v0.1";
  rows: ProofWindowProjection[];
  claim_ceiling: "SANITIZED_READ_MODEL_NOT_RAW_EVIDENCE";
}

const exactProjectionKeys = [
  "schema_version",
  "mission_id",
  "public_title",
  "mission_state",
  "evidence_state",
  "gate_decision",
  "mandatory_passed",
  "mandatory_total",
  "cost_usd",
  "hold_reason_code",
  "last_receipt_sha256",
  "updated_at_utc",
  "training_rights",
  "claim_ceiling",
].sort();

export function isProofWindowProjection(
  value: unknown,
): value is ProofWindowProjection {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  const row = value as Record<string, unknown>;
  if (Object.keys(row).sort().join("|") !== exactProjectionKeys.join("|")) {
    return false;
  }
  return (
    row.schema_version === PROOF_WINDOW_SCHEMA &&
    row.claim_ceiling === "SANITIZED_READ_MODEL_NOT_RAW_EVIDENCE" &&
    typeof row.mission_id === "string" &&
    typeof row.public_title === "string" &&
    !row.public_title.includes("?") &&
    typeof row.last_receipt_sha256 === "string" &&
    /^[0-9A-F]{64}$/.test(row.last_receipt_sha256) &&
    typeof row.mandatory_passed === "number" &&
    typeof row.mandatory_total === "number" &&
    typeof row.cost_usd === "number"
  );
}
